import { createFileRoute } from "@tanstack/react-router";
import { Table } from "@heroui/react";

import { AddBlackListModal, RemoveBlackListModal } from "@/features/black-list";
import { BlackListEntity } from "@/features/black-list/types.ts";
import { useBlackList } from "@/features/black-list/use-black-list.ts";
import { PageLayout } from "@/shared/components/page-layout.ui.tsx";
import { formatDateTime } from "@/shared/helper/datetime.ts";

export const Route = createFileRoute("/dashboard/black-list")({
  component: RouteComponent,
});

function RouteComponent() {
  const { data } = useBlackList();

  return (
    <PageLayout actions={<AddBlackListModal />} title="Чёрный список SMS">
      <p className="px-4 text-sm text-default-500">
        На номера из списка SMS не отправляются: запрос принимается, но
        сообщение не уходит.
      </p>

      <Table.Root>
        <Table.Content aria-label="Чёрный список номеров">
          <Table.Header>
            <Table.Column>ID</Table.Column>
            <Table.Column>Номер</Table.Column>
            <Table.Column>Причина</Table.Column>
            <Table.Column>Добавлен</Table.Column>
            <Table.Column> </Table.Column>
          </Table.Header>
          <Table.Body items={data.data} renderEmptyState={() => "Список пуст"}>
            {(item: BlackListEntity) => (
              <Table.Row id={String(item.id)}>
                <Table.Cell>{item.id}</Table.Cell>
                <Table.Cell>{item.phone}</Table.Cell>
                <Table.Cell>{item.reason || "—"}</Table.Cell>
                <Table.Cell>{formatDateTime(item.createdAt)}</Table.Cell>
                <Table.Cell>
                  <div className="flex flex-row gap-2 justify-end">
                    <RemoveBlackListModal id={item.id} phone={item.phone} />
                  </div>
                </Table.Cell>
              </Table.Row>
            )}
          </Table.Body>
        </Table.Content>
      </Table.Root>
    </PageLayout>
  );
}
